import { DialogProps } from '@design-system/dialog';

import { ModalExternal } from './models';

export const modalExternalMapper = (
  modalExternal: ModalExternal
): DialogProps => {
  const {
    secondaryButtonLabel,
    primaryButtonLabel,
    headline,
    description,
    closeAriaLabel,
    primaryButtonAriaLabel,
    secondaryButtonAriaLabel,
    mode,
    showIcon,
    showCloseButton,
    showOverlay,
  } = modalExternal;

  return {
    primaryButtonLabel,
    secondaryButtonLabel,
    ...(headline && { title: headline }),
    ...(description && { description }),
    ...(mode && { mode }),
    ...(showIcon && { showIcon }),
    ...(showCloseButton && { showCloseButton }),
    ...(showOverlay && { showOverlay }),
    ...(closeAriaLabel && { closeAriaLabel }),
    ...(primaryButtonAriaLabel && { primaryButtonAriaLabel }),
    ...(secondaryButtonAriaLabel && { secondaryButtonAriaLabel }),
  } as DialogProps;
};
